import { render } from "./PublicView.vue?vue&type=template&id=2bab00a6&scoped=true"
import script from "./PublicView.vue?vue&type=script&lang=js"
export * from "./PublicView.vue?vue&type=script&lang=js"

import "./PublicView.vue?vue&type=style&index=0&id=2bab00a6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bab00a6"]])

export default __exports__